export const MOCK_API: string = 'http://localhost:3000';
export const REST_API: string = 'http://localhost:3000';



// WEBPACK FOOTER //
// ./src/config/api.config.ts